// eslint-disable-next-line import/prefer-default-export
export const speciesDisplay = species =>
  `${species.latin_name}${species.english_name ? ` (${species.english_name})` : ''}`;
